import { range } from 'lodash-es';
import { LOCALE_DEFAULT } from '@model/const/locales';

// TODO: https://en.wikipedia.org/wiki/God_object

export default {
    globalOverflowProperty(overflow) {
        if (typeof window === 'undefined') return;

        const isValid = ['hidden', 'visible', 'auto', 'scroll'].includes(overflow);
        if (!isValid) return;

        document.documentElement.style.overflow = overflow;
    },

    handleHtmlInTranslations(source, replacements) {
        let result = source || '';
        replacements.forEach((item) => {
            const regex = RegExp(String.raw`${item.target}\('(.*?)'\)`, 'g');
            result = result.replace(regex, item.replacement);
        });
        return result;
    },

    buildImageLink(baseURL, template, imageId = '', extension = 'png') {
        return `${baseURL}/images/${template}/${imageId.replace('@', '')}.${extension}`;
    },

    isSafariBrowser() {
        const ua = window.navigator.userAgent; // eslint-disable-line n/no-unsupported-features/node-builtins
        return ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1;
    },

    getArrayOfMonths(locale = LOCALE_DEFAULT, month = 'long') {
        const options = { month: month as Intl.DateTimeFormatOptions['month'] };
        return range(1, 13).map((m) => new Date(`2000/${m}/1`).toLocaleString(locale, options));
    },

    slugify(input: string): string {
        // https://gist.github.com/hagemann/382adfc57adbd5af078dc93feef01fe1

        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
        const p = new RegExp(a.split('').join('|'), 'g');

        return input
            .toString()
            .toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
            .replace(/&/g, '-and-') // Replace & with 'and'
            .replace(/[^\w-]+/g, '') // Remove all non-word characters
            .replace(/--+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of a text
            .replace(/-+$/, ''); // Trim - from the end of a text
    },

    getTelLink(telString = '') {
        return `tel:+${(telString || '').replaceAll(/\D/g, '')}`;
    },

    async toSHA256String(inputString: string) {
        const inputBytes = new TextEncoder().encode(inputString);
        const digest = await globalThis.crypto.subtle.digest('SHA-256', inputBytes);
        const outputBytes = new Uint8Array(digest);
        const hex = Array.from(outputBytes)
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');

        return hex;
    },

    sanitize(str: string) {
        return str.replace(/<[^>]*>?/gm, '');
    },

    rangeRec(low, hi, values) {
        if (low > hi) return values;
        values.push(low);
        return this.rangeRec(low + 1, hi, values);
    },

    range(low, hi) {
        return this.rangeRec(low, hi, []);
    },

    scrollTop() {
        if (typeof document === 'undefined') return;
        document.scrollingElement.scrollTo({ top: 0, behavior: 'smooth' });
    },

    /**
     * Regular expressions work for simple cases but can break with more complex HTML structures.
     * Use it for SSR cases only. For client side use DOMParser or some other document related approaches.
     * @param html
     */
    stripHtmlTags(html = '') {
        return html
            .replace(/<\/?[^>]+(>|$)/g, '')
            .replace(/&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;/g, '');
    },

    /**
     * Turns CMS text into plain text suitable for an image `alt` — titles are often HTML rendered via v-html.
     */
    altText(value: unknown): string {
        if (typeof value !== 'string') return '';
        return value
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .replace(/&amp;/gi, '&')
            .replace(/&lt;/gi, '<')
            .replace(/&gt;/gi, '>')
            .replace(/&quot;/gi, '"')
            .replace(/&(?:#0*39|apos);/gi, "'")
            .replace(/\s+/g, ' ')
            .trim();
    },
};
